import React from 'react'
import { Flex, Layout, Button, Carousel } from 'antd'
import { isDesktop } from 'react-device-detect'


import FOTO1 from '../img/fotos/foto1.jpg'
import FOTO2 from '../img/fotos/foto2.jpg'
import FOTO3 from '../img/fotos/foto3.jpg'
import FOTO4 from '../img/fotos/foto4.jpg'


const contentStyle = {
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
};

export const Home = (props) => {



    function renderDestop() {
        return <Flex vertical style={{ fontSize: 18 }}>

            <Flex justify='center' style={{ width: '100%' }}>
                <Carousel arrows dots={true} style={{ width: isDesktop ? 1024 : '100%' }} autoplay={{ dotDuration: true }} autoplaySpeed={5000}>
                    <div>
                        <img src={FOTO1} alt='foto1' style={{ width: '100%', objectFit: 'cover' }} />
                    </div>
                    <div>
                        <img src={FOTO2} alt='foto1' style={{ width: '100%', objectFit: 'cover' }} />
                    </div>
                    <div>
                        <img src={FOTO3} alt='foto1' style={{ width: '100%', objectFit: 'cover' }} />
                    </div>
                    <div>
                        <img src={FOTO4} alt='foto1' style={{ width: '100%', objectFit: 'cover' }} />
                    </div>
                </Carousel>

            </Flex>

            <Flex justify='center' style={{ width: '100%' }}>
                <Flex style={{ padding: 25, width: isDesktop ? 1024 : '100%', backgroundColor: 'white' }} vertical justify='center' >
                    <span style={{ fontSize: 18 }}>
                        &nbsp;&nbsp;A <b>Academia Cearense de Química</b>, ACQ, fundada em 26 de maio de 2008,com sede e foro na cidade de Fortaleza,
                        Estado do Ceará, instalada provisoriamente nas dependências do Conselho Regional de Química da 10ª. Região,
                        situado à Rua Floriano Peixoto, 2020, bairro José Bonifácio, CEP 60025-131, é uma sociedade civil de direito
                        privado, sem fins lucrativos, religiosos ou políticos, com tempo de duração indeterminado.
                    </span>


                    <h2 style={{ marginTop: 50 }}>Objetivos principais da ACQ: </h2>
                    <Flex style={{ marginLeft: 8 }}><b>•	Desenvolvimento científico e industrial:</b></Flex>
                    <Flex style={{ marginLeft: 20 }}>Encorajar o avanço da Química e de sua aplicação na indústria dentro do Ceará.</Flex>
                    <Flex style={{ marginLeft: 8, marginTop: 10 }}><b>•	Disseminação do conhecimento:</b></Flex>
                    <Flex style={{ marginLeft: 20 }}> Reunir, selecionar e divulgar informações que promovam o progresso científico e tecnológico da área.</Flex>
                    <Flex style={{ marginLeft: 8, marginTop: 10 }}><b>•	Aprimoramento da educação:                        </b></Flex>
                    <Flex style={{ marginLeft: 20 }}> Estimular o aprimoramento da Química e a melhoria da qualidade do ensino relacionado.</Flex>
                    <Flex style={{ marginLeft: 8, marginTop: 10 }}><b>•	Ética e conduta profissional:</b></Flex>
                    <Flex style={{ marginLeft: 20 }}>  Manter os princípios de concórdia e ética na prática profissional da Química.</Flex>
                    <Flex style={{ marginLeft: 8, marginTop: 10 }}><b>•	Preservação da memória:</b></Flex>
                    <Flex style={{ marginLeft: 20 }}>Guardar e valorizar a história da Química no Ceará.</Flex>




                    


                    <Flex vertical gap={5} style={{ marginTop: 50 }}>
                        <h2>Localização</h2>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.3206866098917!2d-38.5315352!3d-3.7401342000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c749039d16e961%3A0x545de3112a07e258!2sR.%20Floriano%20Peixoto%2C%202020%20-%20Centro%2C%20Fortaleza%20-%20CE%2C%2060025-131!5e0!3m2!1spt-BR!2sbr!4v1757596531830!5m2!1spt-BR!2sbr"
                            width="100%" height="400" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">

                        </iframe>
                    </Flex>

                </Flex>
            </Flex>
        </Flex>
    }


    function renderMobile() {
        return <Flex vertical style={{ fontSize: 18 }}>
            <Carousel arrows dots={true} style={{ width: '100%' }} autoplay={{ dotDuration: true }} autoplaySpeed={5000}>
                <div>
                    <img src={FOTO1} alt='foto1' style={{ width: '100%', objectFit: 'cover' }} />
                </div>
                <div>
                    <img src={FOTO2} alt='foto1' style={{ width: '100%', objectFit: 'cover' }} />
                </div>
                <div>
                    <img src={FOTO3} alt='foto1' style={{ width: '100%', objectFit: 'cover' }} />
                </div>
                <div>
                    <img src={FOTO4} alt='foto1' style={{ width: '100%', objectFit: 'cover' }} />
                </div>
            </Carousel>


            <Flex style={{ padding: 25, width: '100%', backgroundColor: 'white' }} vertical justify='center' >
               <span style={{ fontSize: 18 }}>
                        &nbsp;&nbsp;A <b>Academia Cearense de Química</b>, ACQ, fundada em 26 de maio de 2008,com sede e foro na cidade de Fortaleza,
                        Estado do Ceará, instalada provisoriamente nas dependências do Conselho Regional de Química da 10ª. Região,
                        situado à Rua Floriano Peixoto, 2020, bairro José Bonifácio, CEP 60025-131, é uma sociedade civil de direito
                        privado, sem fins lucrativos, religiosos ou políticos, com tempo de duração indeterminado.
                    </span>

                <h2 style={{ marginTop: 50 }}>Objetivos principais da ACQ: </h2>
                <Flex style={{ marginLeft: 8 }}><b>•	Desenvolvimento científico e industrial:</b></Flex>
                <Flex style={{ marginLeft: 20 }}>Encorajar o avanço da Química e de sua aplicação na indústria dentro do Ceará.</Flex>
                <Flex style={{ marginLeft: 8, marginTop: 10 }}><b>•	Disseminação do conhecimento:</b></Flex>
                <Flex style={{ marginLeft: 20 }}> Reunir, selecionar e divulgar informações que promovam o progresso científico e tecnológico da área.</Flex>
                <Flex style={{ marginLeft: 8, marginTop: 10 }}><b>•	Aprimoramento da educação:                        </b></Flex>
                <Flex style={{ marginLeft: 20 }}> Estimular o aprimoramento da Química e a melhoria da qualidade do ensino relacionado.</Flex>
                <Flex style={{ marginLeft: 8, marginTop: 10 }}><b>•	Ética e conduta profissional:</b></Flex>
                <Flex style={{ marginLeft: 20 }}>  Manter os princípios de concórdia e ética na prática profissional da Química.</Flex>
                <Flex style={{ marginLeft: 8, marginTop: 10 }}><b>•	Preservação da memória:</b></Flex>
                <Flex style={{ marginLeft: 20 }}>Guardar e valorizar a história da Química no Ceará.</Flex>




               
                <Flex vertical gap={5} style={{ marginTop: 50 }}>
                    <h2>Localização</h2>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.3206866098917!2d-38.5315352!3d-3.7401342000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c749039d16e961%3A0x545de3112a07e258!2sR.%20Floriano%20Peixoto%2C%202020%20-%20Centro%2C%20Fortaleza%20-%20CE%2C%2060025-131!5e0!3m2!1spt-BR!2sbr!4v1757596531830!5m2!1spt-BR!2sbr"
                        width="100%" height="400" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">

                    </iframe>
                </Flex>

            </Flex>

        </Flex>
    }



    return isDesktop ? renderDestop() : renderMobile()

}

export default Home